import './style.scss';

import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { Button } from '@components/Button/Button';
import { IEditableNumberConfig } from '@components/common/UTable/UTable';
import { Input, InputNumber } from 'antd';
import React, { useEffect, useState } from 'react';

type EditableNumberCellProps = {
  value: number;
  record: any;
  config: IEditableNumberConfig;
};

export const EditableNumberCell: React.FC<EditableNumberCellProps> = ({
  value,
  record,
  config,
}) => {
  const { step = 1, min, max, precision, onSave, extraField, width } = config;
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState<number>(value ?? 0);
  const [extraValue, setExtra] = useState<string>();

  useEffect(() => {
    setDraft(value ?? 0);
  }, [value]);

  const limitValue = (v: number) => {
    if (min !== undefined && v < min) return min;
    if (max !== undefined && v > max) return max;
    return v;
  };

  if (!editing) {
    return (
      <div className="editable-cell-wrapper">
        <span>{value ?? 0}</span>
        <Button
          type={'text'}
          onClick={() => setEditing(true)}
          icon={<EditOutlined />}
          display={config?.displayEditButton}
        />
      </div>
    );
  }

  return (
    <div className="editable-cell-wrapper">
      <div className="editable-cell-input">
        <div
          className="editable-cell-wrapper"
          style={width ? { minWidth: width } : undefined}>
          <Button
            type={'text'}
            icon={<MinusOutlined />}
            onClick={() => setDraft((v) => limitValue((v ?? 0) - step))}
          />
          <InputNumber
            value={draft}
            onChange={(v) => setDraft(Number(v ?? 0))}
            min={min}
            max={max}
            step={step}
            precision={precision}
          />
          <Button
            type={'text'}
            icon={<PlusOutlined />}
            onClick={() => setDraft((v) => limitValue((v ?? 0) + step))}
          />
        </div>
        {extraField && (
          <div className="editable-cell-extra">
            {extraField.title && <span>{extraField.title}:</span>}
            <Input
              value={extraValue}
              allowClear
              placeholder={extraField.placeholder}
              onChange={(e) => {
                const v = e.target.value;
                setExtra(v);
                extraField?.onChange?.(v);
              }}
              disabled={extraField.disabled}
              maxLength={extraField.maxLength}
            />
          </div>
        )}
      </div>
      <Button
        shape={'circle'}
        icon={<CheckOutlined />}
        onClick={() => {
          onSave(record, limitValue(draft), extraValue);
          setExtra(undefined);
          setEditing(false);
        }}
      />
      <Button
        shape={'circle'}
        icon={<CloseOutlined />}
        onClick={() => {
          setEditing(false);
          setExtra(undefined);
        }}
      />
    </div>
  );
};
